<template>
	<div class="full">
		<vxe-grid v-bind="gridOptions" v-if="gridOptions" :loading="loading" ref="preoutorderLog"></vxe-grid>
	</div>
</template>
<style scoped>

</style>
<script>
	export default {
		props: {
			currentRow: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				loading: false,
				gridOptions: null,
				toolbarButton:[],
				detail:[]
			}
		},
		watch: {
			currentRow(e) {
				if (e) {
					this.$api.log.list({
						uniquecode:e.salercpt_no,
						formname:'c_preoutorder',
					}).then((res) => {
						console.log(this.currentRow.splitdetail,res)
						this.$refs.preoutorderLog.reloadData(res)
					})
				} else {
					this.tableData = []
				}
			}
		},
		computed: {

		},
		created() {

		},
		mounted() {
			this.gridOptions = this.getOption()	
		},
		methods: {
			getOption() {
				return {
					id: 'preoutorderLog',
					border: true,
					size: 'mini',
					columns: this.getColumns(),
					columnConfig: {
						isHover: false,
						resizable: true
					},
					customConfig: {
						storage: true
					},
					cellStyle:this.cellStyle,
					toolbarConfig: {
						size: 'mini',
						perfect: false,
						buttons: [],
						customConfig: {
							storage: true
						},
					},
					rowConfig: {
						isHover: true,
						isCurrent: true,
					},
					showOverflow: true,
					height: 'auto',
					pagerConfig: {
						enable: false
					},
					proxyConfig: {},
					sortConfig: {
						remote: false
					}
				}
			},
			getColumns() {
				return [{
					field: 'staffid',
					title: '操作人',
					formatter:({row})=>{
						return window.systemMethods.getstaff(row.staffid)
					}
				}, {
					field: 'detail',
					title: '拆分商品',
					formatter:({row})=>{
						let arr = []
						let warehouse = ''
						for(let i in row.param){
							warehouse = row.param[i].storage_name
							arr.push(row.param[i].spec_code + '【'+ row.param[i].tp_item_size + '】')
						}
						return arr.join(',') + '——>' + warehouse

					}
				}, {
					field: 'create_time',
					title: '操作时间',
					formatter:({row})=>{
						return window.systemMethods.timestampToDate(row.create_time,false)
					}
				}]
			}
		},
		components: {
			
		}
	}
</script>